import 'lazyloadxt/dist/jquery.lazyloadxt.min';
import 'lazyloadxt/dist/jquery.lazyloadxt.bootstrap.min';
import 'lazyloadxt/dist/jquery.lazyloadxt.bg.min';



// WEBPACK FOOTER //
// ./scripts/autoload/_lazyloadxt.js